<div class="headrules">
    <h1>Модерация платформ</h1>
</div>
<div class="rulesblockbg">
    <p>1.1. Администрация сервера вправе вынести наказания по зафиксированному нарушению с модерируемых платформ.</p>

    <p>1.2. Под модерацией находятся следующие платформы:<br>
    Игровые сервера проекта.<br>
    Официальные дискорд каналы проекта.<br>
    Twitch / Youtube каналы медиа-партнеров.<br>
    Видеоматериалы и скриншоты игроков проекта расположенных на доступных видео и фото хостингах.<br>
    Личные сообщения между администратором и игроком.<br>
    Форум проекта.<br>
    Внутриигровые функциональные системы.<br>
    <b>Пример:</b> автомобильные номера, ID карта, удостоверение, маркетплейс, диалоги с ботами, в которых интегрированы ИИ и т.п.<br>
    <b>Пояснение:</b> в подобных системах запрещено любое нарушение правил сервера, начиная от запрещенных слов / контента, заканчивая оскорблением родных.</p>
    
    <p>2. Наказание по зафиксированным нарушением выдается согласно общему регламенту проекта.</p>
    
    <p>3. Сообщения между игроками не входят в зону модерации администрацией.<br>
    <b>Исключение:</b> распространение / угрозы распространения личной информации, покупка / продажа игрового имущества за реальные деньги, распространение закрытой информации, использование / распространение / продажа запрещенного ПО, угрозы в реальной жизни и др. грубые нарушения.</p>
    
    <p>4. В случае грубого нарушения человек, оформляющий жалобу, может воспользоваться любым видеоматериалом из перечисленных платформ, дабы доказать нарушение игрока.<br>
    <b>Пример:</b> распространение / угрозы распространения личной информации, покупка / продажа игрового имущества за реальные деньги, распространение закрытой информации, использование / распространение / продажа запрещенного ПО и др. грубые нарушения.</p>
    
    <p>5. Запрещено использовать запрещенные стримерской платформой (twitch, youtube и др.) слова, высказывания, предложения и прочее. <b>| Mute 60-120 минут / Ban 3-10 дней / HardBan 15-30 дней / PermBan.</b></p>
    
    <p>6.1. Запрещен намеренный "стрим-снайп". <b>| Ban 7-30 дней / HardBan 15-30 дней.</b><br>
    <b>Пояснение:</b> помеха стримерам / ютуберам, порча им игрового процесса, слишком навязчивая помощь без надобности / просьб и т.п.</p>
    
    <p>6.2. Запрещено оказывать помощь стримерам, передавать деньги, подарки, предлагать рукопожатия и т.п. действия. <b>| Kick / Demorgan 15 минут / HardBan 7 дней.</b><br>
    <b>Исключение:</b> просьба / инициатива самого стримера.</p>
</div>